import {project1} from '../assets/projects';

 export const projects =[
    {
        id:'1',
        name:"React-movies",
        description: ['React.js', 'sass', 'Axios', 'API'],
        img: project1,
        details:"React-movies is a fully responsive and sleek Movie App built using react library. Users can search for their favorite movies by filtering from an array of categories, watching the trailer for that movie, and choosing movies from different categories.  ",
        link:"https://www.movies.anthony-hong.com",
        github:"https://github.com/hong710/react-movies-TMDB"
    },
    // {
    //     id:'2',
    //     name:"crypto",
    //     description: ['React.js', 'Tailwind', 'Firebase', 'Node.js', 'API'],
    //     img: project1,
    //     details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit, tenetur error, harum nesciunt ipsum debitis quas aliquid.",
    //     link:"",
    //     github:""
    // },
    // {
    //     id:'2',
    //     name:"React-movies",
    //     description: ['React.js', 'sass', 'Axios', 'API'],
    //     img: project2,
    //     details:"React-movies is a fully responsive and sleek Movie App built using react library. Users can search for their favorite movies by filtering from an array of categories, watching the trailer for that movie, and choosing movies from different categories.  ",
    //     link:"https://react-movie-anthony.netlify.app/",
    //     github:"https://github.com/hong710/react-movies-TMDB"
    // },
    // {
    //     id:'3',
    //     name:"zillow",
    //     description: ['React.js', 'Tailwind', 'Firebase', 'Node.js', 'API'],
    //     img:project3,
    //     details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit, tenetur error, harum nesciunt ipsum debitis quas aliquid.",
    //     link:"",
    //     github:""
    // },
    // {
    //     id:'4',
    //     name:"Twitch UI",
    //     description: ['React.js', 'Tailwind', 'Firebase', 'Node.js', 'API'],
    //     img: project4,
    //     details:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit, tenetur error, harum nesciunt ipsum debitis quas aliquid.",
    //     link:"",
    //     github:""
    // }

] 

